import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import TikTokUploadCreativeAudienceFields from './TikTokUploadCreativeAudienceFields'

import { selectedPartnershipSelector } from '../../../../../../../modules/selectors/partnerships'

import useStyles from '../../../../../../../styles/common/stepForms'

const CustomAudiencesStep = ({ formik }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  const selectedPartnership = useSelector(selectedPartnershipSelector)

  const { rights_holder_name: rightsHolderName } = selectedPartnership

  return (
    <>
      <div className={classes.stepTitle}>
        {t('Do you want to target ')}
        {rightsHolderName}
        {t(' audiences?')}
      </div>
      <div className={classes.stepBody}>
        <TikTokUploadCreativeAudienceFields formik={formik} />
      </div>
    </>
  )
}

export default CustomAudiencesStep
